"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyStatusFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _multiValueSearchQueryField = require("../multi-value-search-query-field");
var _parseSlugs = require("../../utils/parse-slugs");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DefaultForListingType = {
  SALES_RESIDENTIAL: ['FOR_SALE', 'UNDER_OFFER'],
  DEVELOPMENTS_RESIDENTIAL: ['FOR_SALE', 'UNDER_OFFER'],
  RENTAL_RESIDENTIAL: ['AVAILABLE_FOR_RENT', 'UNDER_APPLICATION']
};
class PropertyStatusFilter extends _multiValueSearchQueryField.MultiValueSearchQueryField {
  get validListingTypes() {
    return [..._node.SaleListingTypeKeys, ..._node.RentListingTypeKeys, 'DEVELOPMENTS_RESIDENTIAL'];
  }
  constructor(searchOptions, values) {
    super(searchOptions, (0, _node.getPropertyStatusForType)(searchOptions.listingType), values, DefaultForListingType[searchOptions.listingType] || []);
    _defineProperty(this, "urlSlug", PropertyStatusFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q, p) {
    var values = p.listingType === 'sold' ? [...new Set([_node.PropertyStatus.SOLD.name, ...((0, _parseSlugs.parseSlugs)(_node.PropertyStatus, q[PropertyStatusFilter.urlSlug]) || [])])] : (0, _parseSlugs.parseSlugs)(_node.PropertyStatus, q[PropertyStatusFilter.urlSlug]);
    return new PropertyStatusFilter(searchOptions, values);
  }
}
exports.PropertyStatusFilter = PropertyStatusFilter;
_defineProperty(PropertyStatusFilter, "urlSlug", 'status');